import { Grid } from '@chakra-ui/react'
import React from 'react'
import { ProductItem } from './ProductItem'

export const ProductList = ({
  list,
  handleSelectProduct,
  selectedProducts,
}) => {
  return (
    <Grid templateColumns="repeat(3, 1fr)" gap={'20px'} position="relative">
      {list.map((item, index) => (
        <ProductItem
          key={item.codigo_produto}
          item={item}
          handleSelectProduct={handleSelectProduct}
          productSelected={selectedProducts.find(
            (product) => product.codigo_produto === item.codigo_produto,
          )}
        />
      ))}
    </Grid>
  )
}
